import { createInertiaApp } from "@inertiajs/react";
import { createRoot } from "react-dom/client";
import { MarketingAnalytics } from "@/lib/marketing-analytics";
import "@/styles/marketing.css";

const pages = import.meta.glob([
  "../pages/Marketing/**/*.tsx",
  "../pages/Blog/**/*.tsx",
], { eager: true });

createInertiaApp({
  resolve: (name) => pages[`../pages/${name}.tsx`],
  setup({ el, App, props }) {
    createRoot(el).render(
      <>
        <MarketingAnalytics />
        <App {...props} />
      </>
    );
  },
});
